const KeyStraight = ({ color }: { color?: string }) => (
    <svg width="24" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_813_15398)">
            <path d="M7 7.99992C7 9.47268 5.80609 10.6666 4.33333 10.6666C2.86057 10.6666 1.66667 9.47268 1.66667 7.99992C1.66667 6.52716 2.86057 5.33325 4.33333 5.33325C5.80609 5.33325 7 6.52716 7 7.99992ZM7 7.99992H15V9.99992" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.3335 8V10" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_813_15398">
                <rect width="16" height="16" fill="white" transform="translate(0.333496)" />
            </clipPath>
        </defs>
    </svg>
);

export default KeyStraight;
